import styled from "styled-components"

export const StyledSidebar = styled.div`
  grid-area: widget;

  @media (min-width: 1200px) {
    margin-top: 2.75rem;
  }
`
